import React from 'react';
import PropTypes from 'prop-types';
import './faq-item.scss'

const FAQItem = (props) => (
    <div className={`faq-item ${props.isActive ? "faq-item--active" : ""}`} >
        <input type="checkbox" 
            className="faq-item__question-checkbox" 
            id={`question-checkbox-${props.id}`}
            data-id={props.id}
            onChange={props.handleCheckboxChange}
            checked={props.isActive}
        />

        <label className="faq-item__question-label" htmlFor={`question-checkbox-${props.id}`}>{props.question}</label>
        
        <div className="faq-item__extra-options">
            {props.extraQuestion && <div className="faq-item__extra-question">{props.extraQuestion}</div>}

            {props.options && props.options.map((opt, idx) => (
                <div key={idx} 
                    className={`faq-item__radio-group ${parseInt(props.activeOption, 10) === idx ? 
                        "faq-item__radio-group--active" : ""}`}> 
                    
                    <input type="radio" 
                        className="faq-item__radio-btn" 
                        name={`option-${props.id}`} value={opt.option} 
                        id={`option-${props.id}-${idx}`}
                        data-option={idx}
                        data-id={props.id}
                        onChange={props.handleRadioBtnChange} />
                    <label className="faq-item__radio-label" 
                        htmlFor={`option-${props.id}-${idx}`}>{opt.option}</label>
                </div>
            ))}
        </div>    
    </div>
);

FAQItem.propTypes = {
    isActive : PropTypes.bool,
    id: PropTypes.number.isRequired,
    handleCheckboxChange: PropTypes.func.isRequired,
    handleRadioBtnChange: PropTypes.func.isRequired,
    question: PropTypes.string.isRequired,
    extraQuestion: PropTypes.string,
    activeOption: PropTypes.number,
    options: PropTypes.array,
}

export default FAQItem;
